var smoothscroll = require('smoothscroll');

var map = document.querySelector('.location-map');
if(map) {
  mapObj = new XMLHttpRequest();
  mapObj.open('get', 'dist/js/route.json', true);
  mapObj.onload = function(){
    // JSONデータの取得
    var mapData = JSON.parse(this.responseText);

    // URLの取得
    function getMapUrl(n) {
      for(var i = 0, len = mapData.length; i < len; i++) {
        var name = mapData[i].name;
        if(n === name) {
          var url = mapData[i].map_url;
          return url;
        }
      }
    }
    // location-mapまでの高さを取得
    window.addEventListener('load',mapHeight, false);
    window.addEventListener('resize',mapHeight, false);
    function mapHeight() {
      var rect = map.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var mapPosition = rect.top + scrollTop - 43;
      return mapPosition;
    }

    // googleMapリンクのクリックイベント
    var mapChange = document.querySelectorAll('.js-mapchange');
    for(var i = 0, len = mapChange.length; i < len; i++) {
      mapChange[i].onclick = function(){
        var scrollPosition = mapHeight();
        smoothscroll(scrollPosition, 1000);
        var thisName = this.getAttribute('data-name');
        var mapUrl = getMapUrl(thisName);
        var mapArea = document.querySelector('.location-map').children[0];
        mapArea.setAttribute('src', mapUrl);
      }
    }
  }
  mapObj.send(null);
}
